export default __webpack_public_path__ + "static/media/hol-logo.f0b995c0.webp";